
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Head } from "@/components/Head";
import { Converter } from "@/containers/Converter";
import { useTheme } from "@/hooks/useTheme";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { CTASection } from "@/sections/CTASection";
import { MagicianSection } from "@/sections/MagicianSection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import Trans from "next-translate/Trans";
import useTranslation from "next-translate/useTranslation";
import React from "react";

const LucidchartToMiro = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/LucidChartToMiro"
        ogImage="/images/lucidchart2miro-og-image.jpg"
      />

      <MagicianSection
        title={t("page/LucidChartToMiro:title")}
        subtitle={t("page/LucidChartToMiro:subtitle")}
        magicianLogoFile="lucidchart"
        showStartsAt={false}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/LucidChartToMiro:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/LucidChartToMiro:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/lucidchart-to-miro-example.png",
          alt: "LucidChart to Miro Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/LucidChartToMiro:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/lucidchart-to-miro-converted-file-elements.jpg",
          alt: t("page/LucidChartToMiro:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/LucidChartToMiro:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/LucidChartToMiro:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/LucidChartToMiro:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "CHECK-ICON-EMPTY",
            title: t(
              "page/LucidChartToMiro:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/LucidChartToMiro:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("page/LucidChartToMiro:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t(
              "page/LucidChartToMiro:section/conversion.badges.supportsAll",
            ),
          },
          {
            iconType: "NOTES",
            text: t(
              "page/LucidChartToMiro:section/conversion.badges.stickyNotes",
            ),
          },
          {
            iconType: "ARROW-BLACK",
            text: t(
              "page/LucidChartToMiro:section/conversion.badges.connectors",
            ),
          },
        ]}
        elements={{
          from: {
            iconType: "LUCIDCHART",
            image: "/images/miro-lucidchart-preview.jpg",
            title: "LucidChart Demo Preview",
          },
          to: {
            iconType: "MIRO",
            image: "/images/lucidchart-miro-preview.jpg",
            title: "Miro Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.lucidchartToMiroPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default LucidchartToMiro;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/lucidchart-to-miro',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  